import { store } from '../../Models/Store';

export function fetchStoreSingular() {
	return store;
}
